import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { API } from '../api';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Layout from '../components/Layout';

// const NAV = [
//   { icon: '⬡',  label: 'Dashboard',        path: '/dashboard'         },
//   { icon: '👥',  label: 'User Management',  path: '/user-management'   },
// //   { icon: '🌤️', label: 'Season Name',       path: '/season-name'       },
// //   { icon: '📅',  label: 'Season Duration',  path: '/season-duration'   },
// {
//     icon: '🌤️',
//     label: 'Season Management',
//     children: [
//       { icon: '🌤️', label: 'Season Name', path: '/season-name' },
//       { icon: '📅', label: 'Season Duration', path: '/season-duration' }
//     ]
//   },
//   {icon:'⏱️', label:'Rent Durations',  path:'/rent-durations'},
//   { icon: '📋',  label: 'Bookings',         path: '/bookings'          },
//   { icon: '🚘',  label: 'Vehicles',         path: '/vehicles'          },
//   { icon: '👤',  label: 'Customers',        path: '/customers'         },
//   { icon: '💳',  label: 'Payments',         path: '/payments'          },
// ];

const EMPTY_FORM = { period_id: '', from_date: '', to_date: '' };

export default function SeasonDuration() {
  const navigate = useNavigate();

  // ── Sidebar ──
  const [sideOpen,   setSideOpen]   = useState(true);
  const [activePage, setActivePage] = useState('Season Duration');
  const [user,       setUser]       = useState(null);

  // ── Seasons dropdown ──
  const [seasons,    setSeasons]    = useState([]);

  // ── Table ──
  const [data,       setData]       = useState([]);
  const [page,       setPage]       = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total,      setTotal]      = useState(0);
  const [filterSeason, setFilterSeason] = useState(0);
  const [loading,    setLoading]    = useState(false);

  // ── Form ──
  const [form,       setForm]       = useState(EMPTY_FORM);
  const [editId,     setEditId]     = useState(null);
  const [saving,     setSaving]     = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  // ── Auth ──
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) { navigate('/login'); return; }
    setUser(JSON.parse(localStorage.getItem('user') || 'null'));
  }, []);

  // ── Load seasons for dropdowns ──
  useEffect(() => {
    API.get('/seasons', { params: { page: 1, limit: 100, search: '' } })
      .then(r => setSeasons(r.data.data || []))
      .catch(() => toast.error('Failed to load seasons'));
  }, []);

  // ── Fetch durations ──
  const fetchData = useCallback((pg = page, sid = filterSeason) => {
    setLoading(true);
    API.get('/durations', { params: { page: pg, limit: 10, season_id: sid } })
      .then(r => {
        setData(r.data.data);
        setTotalPages(r.data.totalPages);
        setTotal(r.data.total);
      })
      .catch(() => toast.error('Failed to load durations'))
      .finally(() => setLoading(false));
  }, [page, filterSeason]);

  useEffect(() => { fetchData(page, filterSeason); }, [page]);

  // ── Filter by season ──
  const handleFilterChange = (val) => {
    const sid = parseInt(val);
    setFilterSeason(sid);
    setPage(1);
    fetchData(1, sid);
  };

  // ── Form helpers ──
  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleEdit = (row) => {
    setEditId(row.period_durid);
    setForm({
      period_id: row.period_id,
      from_date: row.period_dur_fromdate?.slice(0, 10) || '',
      to_date:   row.period_dur_todate?.slice(0, 10)   || '',
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleCancel = () => { setForm(EMPTY_FORM); setEditId(null); };

  // ── Submit ──
  const handleSubmit = () => {
    if (!form.period_id) { toast.warning('Select a season');    return; }
    if (!form.from_date) { toast.warning('Select From Date');   return; }
    if (!form.to_date)   { toast.warning('Select To Date');     return; }
    if (form.from_date >= form.to_date) {
      toast.warning('From Date must be before To Date'); return;
    }

    setSaving(true);
    const payload = {
      period_id: parseInt(form.period_id),
      from_date: form.from_date,
      to_date:   form.to_date,
    };

    const req = editId
      ? API.put(`/durations/${editId}`, payload)
      : API.post('/durations', payload);

    req
      .then(() => {
        toast.success(editId ? 'Duration updated' : 'Duration added');
        setForm(EMPTY_FORM); setEditId(null);
        fetchData(page, filterSeason);
      })
      .catch(err => toast.error(err.response?.data?.error || 'Operation failed'))
      .finally(() => setSaving(false));
  };

  // ── Delete ──
  const handleDelete = (id) => {
    if (!window.confirm('Delete this duration?')) return;
    API.delete(`/durations/${id}`)
      .then(() => { toast.success('Deleted successfully'); fetchData(page, filterSeason); })
      .catch(err => toast.error(err.response?.data?.error || 'Delete failed'));
  };

  const fmtDate = (d) => d
    ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
    : '—';

  const logout = () => { localStorage.clear(); navigate('/login'); };

  return (
    <Layout activePage="SeasonDuration">
    {/* <div style={S.root}> */}
      <ToastContainer position="top-right" autoClose={3000} />

      {/* ── Sidebar ── */}
      {/* <aside style={{ ...S.sidebar, width: sideOpen ? 220 : 68 }}>
        <div style={S.sideTop}>
          <div style={S.logoWrap}>
            <div style={S.logoIcon}>🚗</div>
            {sideOpen && <span style={S.logoText}>Orisys</span>}
          </div>
          <button style={S.collapseBtn} onClick={() => setSideOpen(p => !p)}>
            {sideOpen ? '◀' : '▶'}
          </button>
        </div>

        <nav style={{ flex: 1 }}>
  {NAV.map((n, i) => (
    <div key={i}> */}
      
      {/* Parent Item */}
      {/* <div
        style={{
          ...S.navItem,
          ...(activePage === n.label ? S.navActive : {})
        }}
        onClick={() => {
          if (n.children) {
            setOpenMenu(openMenu === n.label ? null : n.label);
          } else {
            setActivePage(n.label);
            navigate(n.path);
          }
        }}
      >
        <span style={S.navIcon}>{n.icon}</span>
        {sideOpen && (
          <>
            <span style={S.navLabel}>{n.label}</span>
            {n.children && (
              <span style={{ marginLeft: 'auto' }}>
                {openMenu === n.label ? '▲' : '▼'}
              </span>
            )}
          </>
        )}
      </div> */}

      {/* Child Items */}
      {/* {n.children && openMenu === n.label && (
        <div style={{ marginLeft: sideOpen ? 30 : 0 }}>
          {n.children.map((child, j) => (
            <div
              key={j}
              style={{
                ...S.navItem,
                fontSize: 13,
                paddingTop: '8px',
                paddingBottom: '8px',
                color: '#ccc'
              }}
              onClick={() => {
                setActivePage(child.label);
                navigate(child.path);
              }}
            >
              <span style={S.navIcon}>{child.icon}</span>
              {sideOpen && (
                <span style={S.navLabel}>{child.label}</span>
              )}
            </div>
          ))}
        </div>
      )}

    </div>
  ))}
</nav>

        <div style={S.sideBottom}>
          {sideOpen && (
            <div style={S.userChip}>
              <div style={S.avatar}>{user?.user_name?.[0] || 'A'}</div>
              <div>
                <div style={S.userName}>{user?.user_name || 'Admin'}</div>
                <div style={S.userRole}>Administrator</div>
              </div>
            </div>
          )}
          <button style={S.logoutBtn} onClick={logout}>
            <span>🚪</span>{sideOpen && <span style={{ marginLeft: 8 }}>Logout</span>}
          </button>
        </div>
      </aside> */}

      {/* ── Main ── */}
      <main>

        {/* Page header */}
        <div style={S.header}>
          <div>
            <h2 style={S.title}>Season Duration</h2>
            <p style={S.subtitle}>Assign date ranges to rental seasons</p>
          </div>
        </div>

        {/* ── Add / Edit Form Card ── */}
        <div style={S.card}>
          <div style={S.cardHead}>
            <span style={S.cardHeadTitle}>
              {editId ? '✏️ Edit Duration' : '➕ Add Season Duration'}
            </span>
            {editId && (
              <span style={S.editingBadge}>Editing #{editId}</span>
            )}
          </div>

          <div style={S.formGrid}>
            {/* Season select */}
            <div style={S.formGroup}>
              <label style={S.label}>Season <span style={S.req}>*</span></label>
              <select
                name="period_id"
                value={form.period_id}
                onChange={handleChange}
                style={S.select}
              >
                <option value="">— Select Season —</option>
                {seasons.map(s => (
                  <option key={s.period_id} value={s.period_id}>{s.period_name}</option>
                ))}
              </select>
            </div>

            {/* From date */}
            <div style={S.formGroup}>
              <label style={S.label}>From Date <span style={S.req}>*</span></label>
              <input
                type="date"
                name="from_date"
                value={form.from_date}
                onChange={handleChange}
                style={S.input}
              />
            </div>

            {/* To date */}
            <div style={S.formGroup}>
              <label style={S.label}>To Date <span style={S.req}>*</span></label>
              <input
                type="date"
                name="to_date"
                value={form.to_date}
                min={form.from_date || undefined}
                onChange={handleChange}
                style={S.input}
              />
            </div>

            {/* Buttons */}
            <div style={{ ...S.formGroup, justifyContent: 'flex-end', alignItems: 'flex-end', display: 'flex', gap: 8 }}>
              {editId && (
                <button style={S.cancelBtn} onClick={handleCancel}>Cancel</button>
              )}
              <button style={S.submitBtn} onClick={handleSubmit} disabled={saving}>
                {saving ? 'Saving…' : editId ? 'Update' : 'Add Duration'}
              </button>
            </div>
          </div>
        </div>

        {/* ── Table Card ── */}
        <div style={{ ...S.card, marginTop: 20 }}>

          {/* Table header with filter */}
          <div style={S.tableTopRow}>
            <span style={S.cardHeadTitle}>Manage Durations</span>
            <div style={S.filterWrap}>
              <label style={{ fontSize: 12, color: '#999', marginRight: 8 }}>Filter by Season:</label>
              <select
                value={filterSeason}
                onChange={e => handleFilterChange(e.target.value)}
                style={{ ...S.select, width: 200, padding: '7px 12px' }}
              >
                <option value={0}>— All Seasons —</option>
                {seasons.map(s => (
                  <option key={s.period_id} value={s.period_id}>{s.period_name}</option>
                ))}
              </select>
            </div>
          </div>

          {/* Table */}
          <div style={{ overflowX: 'auto' }}>
            <table style={S.table}>
              <thead>
                <tr style={S.theadRow}>
                  <th style={S.th}>#</th>
                  <th style={S.th}>Season Name</th>
                  <th style={S.th}>From Date</th>
                  <th style={S.th}>To Date</th>
                  {/* <th style={S.th}>Duration</th> */}
                  <th style={{ ...S.th, textAlign: 'right' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={6} style={S.emptyCell}>Loading…</td></tr>
                ) : data.length === 0 ? (
                  <tr><td colSpan={6} style={S.emptyCell}>No records available</td></tr>
                ) : data.map((row, i) => {
                  const from  = new Date(row.period_dur_fromdate);
                  const to    = new Date(row.period_dur_todate);
                  const days  = Math.round((to - from) / (1000 * 60 * 60 * 24));
                  const isEditing = editId === row.period_durid;
                  return (
                    <tr key={row.period_durid} style={{
                      ...S.tr,
                      background: isEditing ? '#f3f2ff' : 'transparent'
                    }}>
                      <td style={S.td}>
                        <span style={S.serial}>{(page - 1) * 10 + i + 1}</span>
                      </td>
                      <td style={S.td}>
                        <span style={S.seasonChip}>{row.period_name}</span>
                      </td>
                      <td style={S.td}>
                        <span style={S.dateChip}>{fmtDate(row.period_dur_fromdate)}</span>
                      </td>
                      <td style={S.td}>
                        <span style={{ ...S.dateChip, background: '#fff8f0', color: '#e07b00' }}>
                          {fmtDate(row.period_dur_todate)}
                        </span>
                      </td>
                      {/* <td style={S.td}>
                        <span style={S.daysChip}>{days} days</span>
                      </td> */}
                      <td style={{ ...S.td, textAlign: 'right' }}>
                        <button style={S.editBtn} onClick={() => handleEdit(row)}>Edit</button>
                        <button style={S.delBtn}  onClick={() => handleDelete(row.period_durid)}>Delete</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div style={S.pagination}>
            <span style={S.paginInfo}>
              {total > 0
                ? `Showing ${(page - 1) * 10 + 1}–${Math.min(page * 10, total)} of ${total}`
                : ''}
            </span>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <button style={S.pgBtn} disabled={page === 1}
                onClick={() => setPage(p => p - 1)}>← Prev</button>
              <span style={S.paginInfo}>Page {page} / {totalPages || 1}</span>
              <button style={S.pgBtn} disabled={page === totalPages || totalPages === 0}
                onClick={() => setPage(p => p + 1)}>Next →</button>
            </div>
          </div>

        </div>
      </main>
    {/* </div> */}
    </Layout>
  );
}

/* ─── Styles ─── */
const S = {
  root: {
    display: 'flex', minHeight: '100vh',
    background: '#f4f6fb', fontFamily: "'DM Sans','Segoe UI',sans-serif"
  },

  /* Sidebar */
  // sidebar: {
  //   background: '#1a1d2e', color: '#fff', display: 'flex', flexDirection: 'column',
  //   position: 'fixed', height: '100vh', transition: 'width 0.25s', overflow: 'hidden', zIndex: 100
  // },
  // sideTop: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '20px 16px 16px' },
  // logoWrap: { display: 'flex', alignItems: 'center', gap: 10 },
  // logoIcon: {
  //   width: 36, height: 36, background: 'linear-gradient(135deg,#6C63FF,#43BCCD)',
  //   borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center',
  //   fontSize: 18, flexShrink: 0
  // },
  // logoText: { fontSize: 18, fontWeight: 800, letterSpacing: '-0.5px', whiteSpace: 'nowrap' },
  // collapseBtn: {
  //   background: 'rgba(255,255,255,0.08)', border: 'none', color: '#aaa',
  //   borderRadius: 6, padding: '4px 8px', cursor: 'pointer', fontSize: 11, flexShrink: 0
  // },
  // navItem: {
  //   display: 'flex', alignItems: 'center', gap: 12,
  //   paddingTop: '11px', paddingBottom: '11px', paddingLeft: '16px', paddingRight: '16px',
  //   cursor: 'pointer', borderRadius: 10, margin: '2px 10px',
  //   color: '#aaa', fontSize: 14, transition: 'all 0.15s', whiteSpace: 'nowrap'
  // },
  // navActive: {
  //   background: 'rgba(99,179,237,0.12)', color: '#63b3ed',
  //   borderLeft: '3px solid #63b3ed', paddingLeft: '13px'
  // },
  // navIcon: { fontSize: 16, flexShrink: 0 },
  // navLabel: { fontWeight: 500 },
  // sideBottom: { padding: '16px', borderTop: '1px solid rgba(255,255,255,0.07)' },
  // userChip: { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 },
  // avatar: {
  //   width: 36, height: 36, background: 'linear-gradient(135deg,#6C63FF,#43BCCD)',
  //   borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
  //   fontWeight: 800, fontSize: 15, flexShrink: 0
  // },
  // userName: { fontSize: 13, fontWeight: 700, color: '#fff' },
  // userRole: { fontSize: 11, color: '#777' },
  // logoutBtn: {
  //   width: '100%', background: 'rgba(255,100,100,0.12)', border: '1px solid rgba(255,100,100,0.2)',
  //   color: '#ff6b6b', borderRadius: 8, padding: '8px 12px', cursor: 'pointer', fontSize: 13,
  //   display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'inherit'
  // },

  /* Main */
  main: { flex: 1, padding: '28px 28px 40px', minWidth: 0, transition: 'margin-left 0.25s' },

  /* Header */
  header: { marginBottom: 20 },
  title: { margin: 0, fontSize: 26, fontWeight: 800, color: '#1a1d2e', letterSpacing: '-0.5px' },
  subtitle: { margin: '4px 0 0', fontSize: 13, color: '#999' },

  /* Card */
  card: {
    background: '#fff', borderRadius: 16,
    boxShadow: '0 2px 16px rgba(0,0,0,0.06)', overflow: 'hidden'
  },
  cardHead: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '16px 20px', borderBottom: '1px solid #f0f0f0'
  },
  cardHeadTitle: { fontSize: 14, fontWeight: 700, color: '#1a1d2e' },
  editingBadge: {
    fontSize: 11, fontWeight: 700, background: '#f3f2ff',
    color: '#6C63FF', borderRadius: 20, padding: '3px 10px'
  },

  /* Form grid — 4 columns */
  formGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 16,
    padding: '20px',
    alignItems: 'end',
  },
  formGroup: { display: 'flex', flexDirection: 'column', gap: 6 },
  label: { fontSize: 12, fontWeight: 600, color: '#555' },
  req: { color: '#ff6b6b' },
  select: {
    padding: '9px 14px', border: '1.5px solid #e0e0e0', borderRadius: 10,
    fontSize: 13, fontFamily: 'inherit', color: '#333', outline: 'none',
    background: '#fff', cursor: 'pointer', width: '100%'
  },
  input: {
    padding: '9px 14px', border: '1.5px solid #e0e0e0', borderRadius: 10,
    fontSize: 13, fontFamily: 'inherit', color: '#333', outline: 'none', width: '100%',
    boxSizing: 'border-box'
  },
  cancelBtn: {
    padding: '9px 18px', background: '#f5f5f5', color: '#666',
    border: 'none', borderRadius: 10, cursor: 'pointer',
    fontSize: 13, fontWeight: 600, fontFamily: 'inherit'
  },
  submitBtn: {
    padding: '9px 22px', background: 'linear-gradient(135deg,#6C63FF,#43BCCD)',
    color: '#fff', border: 'none', borderRadius: 10,
    cursor: 'pointer', fontSize: 13, fontWeight: 700, fontFamily: 'inherit'
  },

  /* Table top row */
  tableTopRow: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '16px 20px', borderBottom: '1px solid #f0f0f0', flexWrap: 'wrap', gap: 12
  },
  filterWrap: { display: 'flex', alignItems: 'center' },

  /* Table */
  table: { width: '100%', borderCollapse: 'collapse' },
  theadRow: { background: '#fafafa' },
  th: {
    padding: '12px 16px', fontSize: 11, fontWeight: 700, color: '#999',
    textAlign: 'left', borderBottom: '2px solid #f0f0f0',
    textTransform: 'uppercase', letterSpacing: '0.5px'
  },
  tr: { transition: 'background 0.12s' },
  td: { padding: '13px 16px', fontSize: 13, color: '#333', borderBottom: '1px solid #f8f8f8' },
  emptyCell: { textAlign: 'center', padding: 40, color: '#bbb', fontSize: 14 },

  /* Chips */
  serial: {
    background: '#f3f2ff', color: '#6C63FF',
    borderRadius: 20, padding: '3px 10px', fontSize: 12, fontWeight: 700
  },
  seasonChip: {
    background: '#f0fff6', color: '#1a9e5c',
    borderRadius: 20, padding: '4px 12px', fontSize: 12, fontWeight: 600
  },
  dateChip: {
    background: '#f0f8ff', color: '#1a6eb5',
    borderRadius: 20, padding: '4px 12px', fontSize: 12, fontWeight: 600
  },
  daysChip: {
    background: '#fff3f0', color: '#d45700',
    borderRadius: 20, padding: '4px 12px', fontSize: 12, fontWeight: 600
  },

  /* Action buttons */
  editBtn: {
    marginRight: 6, background: '#f3f2ff', color: '#6C63FF',
    border: '1px solid #d4d0ff', padding: '5px 14px',
    borderRadius: 20, cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'inherit'
  },
  delBtn: {
    background: '#fff2f5', color: '#FF6584',
    border: '1px solid #ffd0d8', padding: '5px 14px',
    borderRadius: 20, cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'inherit'
  },

  /* Pagination */
  pagination: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '14px 20px', borderTop: '1px solid #f0f0f0'
  },
  paginInfo: { fontSize: 12, color: '#999' },
  pgBtn: {
    padding: '5px 14px', background: '#f3f2ff', color: '#6C63FF',
    border: '1px solid #d4d0ff', borderRadius: 8, cursor: 'pointer',
    fontSize: 12, fontWeight: 600, fontFamily: 'inherit'
  },
};